module.exports = __webpack_public_path__ + "img/public.74fe2c04.svg";